import * as React from 'react'
import * as Editable from '../../../Data/Editable'
import {DeliveryTab} from './DeliveryState'
import {DeliverySubAction} from './DeliveryActions'
import {EditableFloatingActionButtons} from '../../../View/EditableFloatingActionButtons'
import Card from 'material-ui/Card/Card'
import injectSheet from 'react-jss'
import {card, tabs} from '../../../Style'
import {EditableTextField} from '../../../View/EditableTextField'

const styles = {
    ...tabs,
    ...card
}

interface Props {
    readonly active: boolean
    readonly state: DeliveryTab,
    readonly dispatch: (action: DeliverySubAction) => void
}

export const DeliveryTabView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch, active}) => {
            const
                {deliveryAddressForm} = state,
                disabled = Editable.inputsDisabled(deliveryAddressForm),
                deliveryAddress =
                    Editable.withDefault(
                        state.deliveryAddress,
                        deliveryAddressForm)
            return (
                <div className={classes.tabContent}>
                    {active &&
                    <EditableFloatingActionButtons
                        editable={deliveryAddressForm}
                        onEdit={() => dispatch({
                            type: 'EditDelivery',
                        })}
                        onSave={() => dispatch({
                            type: 'SaveDelivery',
                        })}
                        onDiscard={() => dispatch({
                            type: 'DiscardDelivery',
                        })}
                    />}
                    <form className={classes.tabForm}>
                        <Card
                            className={classes.card}
                        >
                            <div className={classes.cardHeader}>
                                Lieferinformationen
                            </div>
                            <div className={classes.cardContent}>
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 1"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryName1}
                                    onChange={event => dispatch({
                                        type: 'DeliveryName1Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 2"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryName2}
                                    onChange={event => dispatch({
                                        type: 'DeliveryName2Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 3"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryName3}
                                    onChange={event => dispatch({
                                        type: 'DeliveryName3Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Name 4"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryName4}
                                    onChange={event => dispatch({
                                        type: 'DeliveryName4Changed',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Straße"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryStreet}
                                    onChange={event => dispatch({
                                        type: 'DeliveryStreetChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Hausnummer"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryHouseNumber}
                                    onChange={event => dispatch({
                                        type: 'DeliveryHouseNumberChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Ebene"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryFloor}
                                    onChange={event => dispatch({
                                        type: 'DeliveryFloorChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Raum"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryRoom}
                                    onChange={event => dispatch({
                                        type: 'DeliveryRoomChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Postleitzahl"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryZipCode}
                                    onChange={event => dispatch({
                                        type: 'DeliveryZipCodeChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Stadt"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryCity}
                                    onChange={event => dispatch({
                                        type: 'DeliveryCityChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Land"
                                    locked={disabled}
                                    value={deliveryAddress.deliveryCountry}
                                    onChange={event => dispatch({
                                        type: 'DeliveryCountryChanged',
                                        value: event.currentTarget.value
                                    })}

                                />
                            </div>
                        </Card>
                    </form>
                    <form className={classes.tabForm}>
                        <Card className={classes.card}>
                            <div className={classes.cardHeader}>
                               Zustell-Status
                            </div>
                            <div className={classes.cardContent}>
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="26.06.2017 09:50"
                                    locked={disabled}
                                    value="max.mustermann@mail.net"
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="26.06.2017 09:59"
                                    locked={disabled}
                                    value="helga.habermann@email.de"
                                />
                            </div>
                        </Card>
                    </form>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/Delivery/DeliveryView.tsx